import { Container, Label, SelectInput } from '@playcanvas/pcui';

import { Events } from '../events';
import { i18n } from './localization';

class AttributionMapsPanel extends Container {
    constructor(events: Events, args = {}) {
        args = {
            ...args,
            id: 'attribution-maps-panel',
            class: 'panel',
            hidden: true
        };

        super(args);

        ['pointerdown', 'pointerup', 'pointermove', 'wheel', 'dblclick'].forEach((eventName) => {
            this.dom.addEventListener(eventName, (event: Event) => event.stopPropagation());
        });

        const title = new Label({ class: 'attribution-maps-panel-title' });
        i18n.bindText(title, 'panel.settings.attribution-maps');

        const row = new Container({ class: 'attribution-maps-panel-row' });
        const label = new Label({ class: 'attribution-maps-panel-label' });
        i18n.bindText(label, 'panel.settings.colormap');

        const selection = new SelectInput({
            class: 'attribution-maps-panel-select',
            defaultValue: events.invokeOptional('view.customChannelColormap') ?? 'grayscale'
        });
        i18n.bindOptions(selection, () => [
            { v: 'grayscale', t: i18n.t('colormap.grayscale') },
            { v: 'viridis', t: i18n.t('colormap.viridis') },
            { v: 'turbo', t: i18n.t('colormap.turbo') }
        ]);
        selection.on('change', (value: string) => {
            events.fire('view.customChannelColormap.set', value);
        });

        row.append(label);
        row.append(selection);
        const hint = new Label({ class: 'panel-data-hint' });
        i18n.bindText(hint, 'panel.attribution-maps.missing-data');

        this.append(title);
        this.append(hint);
        this.append(row);

        const updateAvailability = () => {
            const available = !!events.invokeOptional('selection')?.hasCustomChannel;
            hint.hidden = available;
            row.hidden = !available;
            events.fire('view.customChannel.set', available && !this.hidden);
        };
        const setVisible = (visible: boolean) => {
            this.hidden = !visible;
            updateAvailability();
            events.fire('attributionMapsPanel.visible', visible);
        };
        events.on('selection.changed', updateAvailability);
        events.on('splat.replaced', updateAvailability);
        events.function('attributionMapsPanel.visible', () => !this.hidden);
        events.on('attributionMapsPanel.setVisible', setVisible);
        events.on('attributionMapsPanel.toggleVisible', () => setVisible(this.hidden));
        updateAvailability();
        events.on('view.customChannelColormap', (value: string) => {
            selection.value = value;
        });
    }
}

export { AttributionMapsPanel };
